import { useCallback } from 'react'
import { useUser } from '@fs/zion-user'
import useDataEndpoint from './useDataEndpoint'
import orchestrationApi from '../api/orchestration'

export default function useBookmarks() {
  const user = useUser()
  const signedIn = user?.signedIn || false

  const getBookmarksFn = useCallback(async () => {
    if (signedIn) {
      try {
        return await orchestrationApi.bookmarks.getBookmarks()
      } catch {
        return []
      }
    }

    return Promise.resolve([])
  }, [signedIn])

  const [response, refetchBookmarks, state] = useDataEndpoint(getBookmarksFn)
  if (!signedIn) return []
  const data = response || []
  return [data, refetchBookmarks, state]
}
